import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import '../../CSS/Visiter.css';
import BeninInfo from "../composant_reutilisable/BeninInfo";
import Carousel from "../composant_reutilisable/Carousel";
import Africa from '../../images/Africa.svg';
import pr from '../../images/pr.png';
import voyage from '../../images/voyage.png';
import voyage1 from '../../images/voyage1.png';
import MenuSection from "./menuSection";
import { useLanguageData } from '../../hooks/useLanguageData';
import SafeHTML from "../SafeHTML";

const VisiterChine = () => {
    const { t } = useTranslation();
    
    // Hook pour les liens utiles
    const { 
        data: linksResponse, 
        loading: linksLoading, 
        error: linksError 
    } = useLanguageData('/api/v1/embassy/useful-links-category?slugCategory=lien-site');

    // Hook pour les données pendant_voyage_deu
    const { 
        data: pendantResponse, 
        loading: pendantLoading, 
        error: pendantError 
    } = useLanguageData('/api/v1/embassy/static-data?slug=pendant_voyage_deu_chine');

    const [linksData, setLinksData] = useState([]);
    const [pendantVoyageDeuData, setPendantVoyageDeuData] = useState(null);

    // Traiter les données des liens utiles
    useEffect(() => {
        if (linksResponse?.data && Array.isArray(linksResponse.data)) {
            console.log('📊 Données API liens utiles (VisiterChine):', linksResponse);
            setLinksData(linksResponse.data);
        }
    }, [linksResponse]);

    // Traiter les données pendant_voyage_deu
    useEffect(() => {
        if (pendantResponse?.data && pendantResponse.data.length > 0) {
            console.log('📊 Données pendant_voyage_deu:', pendantResponse);
            setPendantVoyageDeuData(pendantResponse.data[0]);
        }
    }, [pendantResponse]);

    const loading = linksLoading || pendantLoading;
    const error = linksError || pendantError;

    // Trouver les données pour chaque slug
    const avantVoyageUn = linksData.find(item => item.slug === 'avant_voyage_un_chine');
    const avantVoyageDeu = linksData.find(item => item.slug === 'avant_voyage_deu_chine');
    const pendantVoyageUn = linksData.find(item => item.slug === 'pendant_voyage_un_chine');

    return (
        <div className="visiter-container mt-4">
            <div className="visiter-content">
                <MenuSection title={t('visiterChine.welcomeTitle')} showSubtitles={false} />

                {/* 🔽 CONTENEUR AVEC CLASSES CSS */}
                <div className="voyage-container">
                    {/* Premier bloc - Avant le voyage */}
                    {loading ? (
                        <div className="loading-container">
                            <div className="loading-spinner"></div>
                            <p>{t('common.loading')}</p>
                        </div>
                    ) : error ? (
                        <div className="error-container">
                            <div className="error-icon">⚠️</div>
                            <h3>{t('common.error')}</h3>
                            <p>{error}</p>
                        </div>
                    ) : (
                        <>
                            <div className="voyage-bloc">
                                <div className="voyage-content">
                                    {avantVoyageUn?.name && (
                                        <span className="voyage-subtitle">
                                            {avantVoyageUn.name}
                                        </span>
                                    )}
                                    {avantVoyageDeu?.name && (
                                        <span className="voyage-title">
                                            {avantVoyageDeu.name}
                                        </span>
                                    )}
                                    {avantVoyageUn?.description && (
                                        <span className="voyage-description">
                                            <SafeHTML html={avantVoyageUn.description} />
                                        </span>
                                    )}
                                    <div className="voyage-links">
                                        {avantVoyageUn?.textBouton && avantVoyageUn?.linkAccess && (
                                            <a 
                                                className="menu-subtitle" 
                                                href={avantVoyageUn.linkAccess} 
                                                style={{ color: "#0a3764", marginRight: "30px", fontSize: "12px" }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {avantVoyageUn.textBouton}
                                            </a>
                                        )}
                                        {avantVoyageDeu?.textBouton && avantVoyageDeu?.linkAccess && (
                                            <a 
                                                className="menu-subtitle" 
                                                href={avantVoyageDeu.linkAccess} 
                                                style={{ color: "#0a3764", fontSize: "12px" }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {avantVoyageDeu.textBouton}
                                            </a>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    {avantVoyageUn?.imageBanner  ? (
                                        <img 
                                            src={avantVoyageUn.imageBanner} 
                                            className="voyage-image" 
                                            alt={avantVoyageUn.name || t('visiterChine.beforeTravelAlt')}
                                            onError={(e) => {
                                                console.warn('Image non chargée, utilisation image par défaut');
                                                e.target.src = voyage;
                                            }}
                                        />
                                    ) : (
                                        <img src={voyage} className="voyage-image" alt={t('visiterChine.beforeTravelAlt')} />
                                    )}
                                </div>
                            </div>

                            {/* Deuxième bloc - Pendant le voyage */}
                            <div className="voyage-bloc">
                                <div className="voyage-content">
                                    {pendantVoyageUn?.name && (
                                        <span className="voyage-subtitle">
                                            {pendantVoyageUn.name}
                                        </span>
                                    )}
                                    {!pendantLoading && pendantVoyageDeuData?.name && (
                                        <span className="voyage-title">
                                            {pendantVoyageDeuData.name}
                                        </span>
                                    )}
                                    {pendantVoyageUn?.description && (
                                        <span className="voyage-description">
                                            <SafeHTML html={pendantVoyageUn.description} />
                                        </span>
                                    )}
                                    <div className="voyage-links-second">
                                        {pendantVoyageUn?.textBouton && pendantVoyageUn?.linkAccess && (
                                            <a 
                                                className="menu-subtitle" 
                                                href={pendantVoyageUn.linkAccess} 
                                                style={{ color: "#0a3764", marginRight: "35px", fontSize: "12px" }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {pendantVoyageUn.textBouton}
                                            </a>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    {pendantVoyageUn?.imageBanner ? (
                                        <img 
                                            src={pendantVoyageUn.imageBanner} 
                                            className="voyage-image" 
                                            alt={pendantVoyageUn.name || t('visiterChine.duringTravelAlt')}
                                            onError={(e) => {
                                                console.warn('Image non chargée, utilisation image par défaut');
                                                e.target.src = voyage1;
                                            }}
                                        />
                                    ) : (
                                        <img src={voyage1} className="voyage-image" alt={t('visiterChine.duringTravelAlt')} />
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* Styles pour le chargement et les erreurs */}
            <style jsx>{`
                .loading-container, .error-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 2rem;
                    text-align: center;
                    min-height: 200px;
                    width: 100%;
                    grid-column: 1 / -1;
                }

                .loading-spinner {
                    width: 40px;
                    height: 40px;
                    border: 4px solid #f3f3f3;
                    border-top: 4px solid #1a3c5e;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin-bottom: 1rem;
                }

                .error-container {
                    max-width: 700px;
                    width: 100%;
                }

                .error-icon {
                    font-size: 3rem;
                    margin-bottom: 1rem;
                }

                .error-container h3 {
                    color: #d32f2f;
                    margin-bottom: 0.5rem;
                    font-size: 1.5rem;
                }

                .error-container p {
                    color: #666;
                    margin: 0;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .voyage-description p {
                    margin: 0;
                    display: inline;
                }
            `}</style>
        </div>
    );
};

export default VisiterChine;